import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CRow,
  CButton,
  CSpinner,
  CAlert,
} from '@coreui/react';
import useForgotPasswordViewModel from '../viewmodels/ForgotPasswordViewModel';
import { EmailInputGroup } from '../components/InputGroup';

const ForgotPasswordView = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { forgotPassword, loading, error, success } = useForgotPasswordViewModel();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await forgotPassword(email);
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1>Forgot Password</h1>
                    <p className="text-medium-emphasis">
                      Enter your email address and we'll send you a link to reset your password.
                    </p>
                    {error && <CAlert color="danger">{error}</CAlert>}
                    {success && (
                      <CAlert color="success">
                        Password reset instructions have been sent to your email.
                      </CAlert>
                    )}
                    
                    <EmailInputGroup
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />

                    <CRow>
                      <CCol xs={6}>
                        <CButton type="submit" color="primary" className="px-4" disabled={loading}>
                          {loading ? <CSpinner size="sm" /> : 'Send Reset Link'}
                        </CButton>
                      </CCol>
                      <CCol xs={6} className="text-right">
                        <CButton color="link" className="px-0" onClick={() => navigate('/login')}>
                          Back to Login
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ForgotPasswordView;